import { useApolloClient } from '@apollo/react-hooks';
import useWrapWithLoader from '../../../hooks/useWrapWithLoading';
import {
  OutageLookupParams,
  OutageLookupResponse,
} from '../../../__generated__/pge-types';
import { getOutageLookupQuery } from '../queries/queries';
import { useContext } from 'react';
import { NotificationsContext } from '../../../providers/NotificationsProvider';
import { useTranslation } from '../../../hooks/useTranslation';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    alert: {
      margin: '5px 1em',
      '& > .MuiAlert-message > p': {
        margin: 0,
      },
    },
  }),
);

export function useOutageLookUp() {
  const apolloClient = useApolloClient();
  const { wrapWithLoader } = useWrapWithLoader();
  const notificationContext = useContext(NotificationsContext);
  const { t } = useTranslation();
  const classes = useStyles();

  const getOutageLookUpQueryResponse = wrapWithLoader(
    async (params: OutageLookupParams) => {
      const result = await apolloClient.query<
        { getOutageLookup: OutageLookupResponse },
        { params: OutageLookupParams }
      >({
        query: getOutageLookupQuery,
        variables: { params },
        fetchPolicy: 'network-only',
      });
      const getOutageLookupResponse = result?.data?.getOutageLookup;
      return getOutageLookupResponse;
    },
  );

  const setErrorNotification = (isError: boolean) => {
    notificationContext.setState({
      isOpen: isError,
      message: isError
        ? t('GENERIC_ERROR_NOTIFICATION_MESSAGE_BODY')
        : undefined,
      severity: isError ? 'error' : undefined,
      alertStyle: classes.alert,
    });
    isError && typeof window !== 'undefined' && window.scrollTo(0, 0);

    return { setErrorNotification };
  };

  return {
    getOutageLookUpQueryResponse,
    setErrorNotification,
  };
}
